module.exports = __webpack_public_path__ + "img/file-minus.45cb4bc1.svg";